import request from '@/utils/request'

// Creating an account on someone's behalf. Admin only.
// Backend: POST /api/v2/admin/users
// (request baseURL already includes /api/v2).

export interface CreateUserPayload {
  email: string
  firstName: string
  lastName?: string
  // Both or neither. A country code with no number is refused by the backend.
  countryCode?: string
  phoneNumber?: string
  birthDay?: string
}

export interface CreatedUser {
  userId: string
  email: string
  firstName: string
  lastName: string
  countryCode: string | null
  phoneNumber: string | null
}

export const createUserFromAdmin = (payload: CreateUserPayload) =>
  request({ url: '/admin/users', method: 'post', data: payload })
